import type { RouteRecordRaw } from 'vue-router';

export const tableRoute: RouteRecordRaw = {
  path: '/numerals/table',
  name: 'NumeralsTable',
  component: () => import('./pages/NumeralsTablePage.vue'),
  meta: { layout: 'main' },
};

export const builderRoute: RouteRecordRaw = {
  path: '/numerals/builder',
  name: 'NumeralsBuilder',
  component: () => import('./pages/NumeralsBuilderPage.vue'),
  meta: { layout: 'main' },
};

export const declensionRoute: RouteRecordRaw = {
  path: '/numerals/declension',
  name: 'NumeralsDeclension',
  component: () => import('./pages/NumeralsDeclensionPage.vue'),
  meta: { layout: 'main' },
};

export const ordinalRoute: RouteRecordRaw = {
  path: '/numerals/ordinal',
  name: 'NumeralsOrdinal',
  component: () => import('./pages/NumeralsOrdinalPage.vue'),
  meta: { layout: 'main' },
};

export const collectiveRoute: RouteRecordRaw = {
  path: '/numerals/collective',
  name: 'NumeralsCollective',
  component: () => import('./pages/NumeralsCollectivePage.vue'),
  meta: { layout: 'main' },
};

export const kindsRoute: RouteRecordRaw = {
  path: '/numerals/kinds',
  name: 'NumeralsKinds',
  component: () => import('./pages/NumeralsKindsPage.vue'),
  meta: { layout: 'main' },
};

export const multiplicativeRoute: RouteRecordRaw = {
  path: '/numerals/multiplicative',
  name: 'NumeralsMultiplicative',
  component: () => import('./pages/NumeralsMultiplicativePage.vue'),
  meta: { layout: 'main' },
};

export const typesRoute: RouteRecordRaw = {
  path: '/numerals/types',
  name: 'NumeralsTypes',
  component: () => import('./pages/NumeralsTypesPage.vue'),
  meta: { layout: 'main' },
};
